import { Component, ContentChildren, Input, QueryList } from '@angular/core';
import { tabPanelsStyles, TabPanelsProps } from '@kite_aerolab/shared/components';
import { TabPanelComponent } from './tab-panel.component';

@Component({
  selector: 'kite-tab-panels',
  template: `
    <div [ngClass]="tabPanelsStyles">
      <ng-content></ng-content>
    </div>
  `,
})
export class TabPanelsComponent {
  @ContentChildren(TabPanelComponent) tabPanels: QueryList<TabPanelComponent>;
  @Input() activeIndex: number;
  @Input() css: TabPanelsProps['css'];

  public get tabPanelsStyles(): string[] {
    return [tabPanelsStyles({ css: this.css }).className];
  }

  ngAfterViewInit() {
    this.tabPanels.toArray().forEach((tab, index) => {
      tab.activeIndex = this.activeIndex;
      tab.index = index;
    });
  }

  ngAfterContentChecked() {
    this.tabPanels.toArray().forEach((tab) => {
      tab.activeIndex = this.activeIndex;
    });
  }
}
